import React from 'react';
import { SvgIcon } from '@material-ui/core';
import styles from './Icons.module.css';
import classNames from 'classnames';

// eslint-disable-next-line react/display-name
const wrapSvgPath =
  (path, viewBox = '0 0 24 24') =>
  (props) => (
    <SvgIcon {...props} viewBox={viewBox}>
      {path}
    </SvgIcon>
  );

const closeCirclePath = (
  <path
    d="M12,2 C6.5,2 2,6.5 2,12 C2,17.5 6.5,22 12,22 C17.5,22 22,17.5 22,12 C22,6.5 17.5,2 12,2 Z M17,15.6 C17.2,15.8 17.2,16.2 17,16.4 L16.4,17 C16.2,17.2 15.8,17.2 15.6,17 L12,13.4 L8.4,17 C8.2,17.2 7.8,17.2 7.6,17 L7,16.4 C6.8,16.2 6.8,15.8 7,15.6 L10.6,12 L7,8.4 C6.8,8.2 6.8,7.8 7,7.6 L7.6,7 C7.8,6.8 8.2,6.8 8.4,7 L12,10.6 L15.6,7 C15.8,6.8 16.2,6.8 16.4,7 L17,7.6 C17.2,7.8 17.2,8.2 17,8.4 L13.4,12 L17,15.6 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const CloseCircleIcon = wrapSvgPath(closeCirclePath);

const closePath = (
  <path
    d="M21.2,3.8 L20.2,2.8 C20.1,2.7 19.9,2.7 19.8,2.8 L12.2,10.4 C12.1,10.5 11.9,10.5 11.8,10.4 L4.2,2.8 C4.1,2.7 3.9,2.7 3.8,2.8 L2.8,3.8 C2.7,3.9 2.7,4.1 2.8,4.2 L10.4,11.8 C10.5,11.9 10.5,12.1 10.4,12.2 L2.8,19.8 C2.7,19.9 2.7,20.1 2.8,20.2 L3.8,21.2 C3.9,21.3 4.1,21.3 4.2,21.2 L11.8,13.6 C11.9,13.5 12.1,13.5 12.2,13.6 L19.8,21.2 C19.9,21.3 20.1,21.3 20.2,21.2 L21.2,20.2 C21.3,20.1 21.3,19.9 21.2,19.8 L13.6,12.2 C13.5,12.1 13.5,11.9 13.6,11.8 L21.2,4.2 C21.3,4.1 21.3,3.9 21.2,3.8 Z"
    id="Path"
    fillRule="nonzero"
  />
);
export const CloseIcon = wrapSvgPath(closePath);

const arrowDownPath = (
  <path
    d="M11.6,17 L4,9.4 C3.8,9.2 3.8,8.8 4,8.6 L4.6,8 C4.8,7.8 5.2,7.8 5.4,8 L11.6,14.2 C11.8,14.4 12.2,14.4 12.4,14.2 L18.6,8 C18.8,7.8 19.2,7.8 19.4,8 L20,8.6 C20.2,8.8 20.2,9.2 20,9.4 L12.4,17 C12.2,17.2 11.8,17.2 11.6,17 Z"
    id="Path"
    fillRule="nonzero"
  />
);
export const ArrowDown = wrapSvgPath(arrowDownPath);

const arrowUp = (
  <path
    d="M18.6,16 L12.4,9.8 C12.2,9.6 11.8,9.6 11.6,9.8 L5.4,16 C5.2,16.2 4.8,16.2 4.6,16 L4,15.4 C3.8,15.2 3.8,14.8 4,14.6 L11.6,7 C11.8,6.8 12.2,6.8 12.4,7 L20,14.6 C20.2,14.8 20.2,15.2 20,15.4 L19.4,16 C19.2,16.2 18.8,16.2 18.6,16 Z"
    id="Path"
    fillRule="nonzero"
  />
);
export const ArrowUp = wrapSvgPath(arrowUp);

const arrowRight = (
  <path
    d="M8.6,20 L8,19.4 C7.8,19.2 7.8,18.8 8,18.6 L14.2,12.4 C14.4,12.2 14.4,11.8 14.2,11.6 L8,5.4 C7.8,5.2 7.8,4.8 8,4.6 L8.6,4 C8.8,3.8 9.2,3.8 9.4,4 L17,11.6 C17.2,11.8 17.2,12.2 17,12.4 L9.4,20 C9.2,20.2 8.8,20.2 8.6,20 Z"
    id="Path"
    fillRule="nonzero"
  />
);
export const ArrowRight = wrapSvgPath(arrowRight);

const arrowLeft = (
  <path
    d="M14.6,20 L7,12.4 C6.8,12.2 6.8,11.8 7,11.6 L14.6,4 C14.8,3.8 15.2,3.8 15.4,4 L16,4.6 C16.2,4.8 16.2,5.2 16,5.4 L9.8,11.6 C9.6,11.8 9.6,12.2 9.8,12.4 L16,18.6 C16.2,18.8 16.2,19.2 16,19.4 L15.4,20 C15.2,20.2 14.8,20.2 14.6,20 Z"
    id="Path"
    fillRule="nonzero"
  />
);
export const ArrowLeft = wrapSvgPath(arrowLeft);

const AppSvg = ({ viewBox = '0 0 24 24', children, ...props }) => (
  <svg viewBox={viewBox} {...props}>
    {children}
  </svg>
);

export const ArrowLeft12 = ({ fill = 'black', className, ...props }) => (
  <AppSvg viewBox="0 0 7 12" className={classNames(styles.size12, className)} {...props}>
    <path
      d="M5.42684 11.8127L0.277561 6.66339C0.175263 6.56111 0.103423 6.4528 0.0620417 6.33846C0.0206804 6.22413 0 6.11131 0 6C0 5.87363 0.0206804 5.75704 0.0620417 5.65025C0.103423 5.54343 0.175263 5.43888 0.277561 5.33661L5.42684 0.1873C5.5517 0.0624334 5.6901 0 5.84203 0C5.99397 0 6.13237 0.0624334 6.25723 0.1873C6.3821 0.312166 6.44453 0.450564 6.44453 0.602496C6.44453 0.754428 6.3821 0.892827 6.25723 1.01769L1.27493 6L6.25723 10.9823C6.3821 11.1072 6.44453 11.2456 6.44453 11.3975C6.44453 11.5494 6.3821 11.6878 6.25723 11.8127C6.13237 11.9376 5.99397 12 5.84203 12C5.6901 12 5.5517 11.9376 5.42684 11.8127Z"
      fill={fill}
    />
  </AppSvg>
);

export const ArrowRight12 = ({ fill = 'black', className, ...props }) => (
  <ArrowLeft12 fill={fill} className={classNames(styles.flipHorizontally, className)} {...props} />
);

const fullScreenIcon = (
  <path
    d="M21.5,8.9 L21.5,3.1 C21.5,2.8 21.3,2.5 20.9,2.5 L15,2.5 C14.7,2.5 14.4,2.7 14.4,3.1 L14.4,4 C14.4,4.3 14.6,4.6 15,4.6 L17,4.6 C17.5,4.6 17.7,5.2 17.4,5.6 L12.5,10.5 C12.3,10.7 11.9,10.7 11.7,10.5 L6.9,5.5 C6.5,5.1 6.8,4.5 7.3,4.5 L9,4.5 C9.3,4.5 9.6,4.3 9.6,3.9 L9.6,3.1 C9.6,2.8 9.4,2.5 9,2.5 L3.1,2.5 C2.8,2.5 2.5,2.7 2.5,3.1 L2.5,9 C2.5,9.3 2.7,9.6 3.1,9.6 L4,9.6 C4.3,9.6 4.6,9.4 4.6,9 L4.6,7.3 C4.6,6.8 5.2,6.6 5.6,6.9 L10.5,11.8 C10.7,12 10.7,12.4 10.5,12.6 L5.6,17.5 C5.2,17.9 4.6,17.6 4.6,17.1 L4.6,15.1 C4.6,14.8 4.4,14.5 4,14.5 L3.1,14.5 C2.8,14.5 2.5,14.7 2.5,15.1 L2.5,21 C2.5,21.3 2.7,21.6 3.1,21.6 L9,21.6 C9.3,21.6 9.6,21.4 9.6,21 L9.6,20.1 C9.6,19.8 9.4,19.5 9,19.5 L7.5,19.5 C7,19.5 6.8,18.9 7.1,18.5 L11.7,13.9 C11.9,13.7 12.3,13.7 12.5,13.9 L17.1,18.5 C17.5,18.9 17.2,19.5 16.7,19.5 L15,19.5 C14.7,19.5 14.4,19.7 14.4,20.1 L14.4,21 C14.4,21.3 14.6,21.6 15,21.6 L20.9,21.6 C21.2,21.6 21.5,21.4 21.5,21 L21.5,15.1 C21.5,14.8 21.3,14.5 20.9,14.5 L20,14.5 C19.7,14.5 19.4,14.7 19.4,15.1 L19.4,16.8 C19.4,17.3 18.8,17.5 18.4,17.2 L13.8,12.6 C13.6,12.4 13.6,12 13.8,11.8 L18.4,7.2 C18.8,6.8 19.4,7.1 19.4,7.6 L19.4,9 C19.4,9.3 19.6,9.6 20,9.6 L20.9,9.6 C21.3,9.5 21.5,9.3 21.5,8.9 Z"
    id="Path"
    fillRule="nonzero"
  />
);
export const FullScreenIcon = wrapSvgPath(fullScreenIcon);

const fullScreenExitIcon = (
  <path
    d="M9.9,13.5 C10.2,13.5 10.5,13.8 10.5,14.1 L10.5,14.1 L10.5,19.9 C10.5,20.2 10.2,20.5 9.9,20.5 L9.9,20.5 L9.1,20.5 C8.8,20.5 8.5,20.2 8.5,19.9 L8.5,19.9 L8.5,18.3 C8.5,17.8 7.9,17.5 7.5,17.9 L7.5,17.9 L3.6,21.8 C3.4,22 3,22 2.8,21.8 L2.8,21.8 L2.2,21.2 C2,21 2,20.6 2.2,20.4 L2.2,20.4 L6.1,16.5 C6.5,16.1 6.2,15.5 5.7,15.5 L5.7,15.5 L4.1,15.5 C3.8,15.5 3.5,15.2 3.5,14.9 L3.5,14.9 L3.5,14.1 C3.5,13.8 3.8,13.5 4.1,13.5 L4.1,13.5 Z M19.9,13.5 C20.2,13.5 20.5,13.8 20.5,14.1 L20.5,14.1 L20.5,14.9 C20.5,15.2 20.2,15.5 19.9,15.5 L19.9,15.5 L18.3,15.5 C17.8,15.5 17.5,16.1 17.9,16.5 L17.9,16.5 L21.8,20.4 C22,20.6 22,21 21.8,21.2 L21.8,21.2 L21.2,21.8 C21,22 20.6,22 20.4,21.8 L20.4,21.8 L16.5,17.9 C16.1,17.5 15.5,17.8 15.5,18.3 L15.5,18.3 L15.5,19.9 C15.5,20.2 15.2,20.5 14.9,20.5 L14.9,20.5 L14.1,20.5 C13.8,20.5 13.5,20.2 13.5,19.9 L13.5,19.9 L13.5,14.1 C13.5,13.8 13.8,13.5 14.1,13.5 L14.1,13.5 Z M2.8,2.2 C3,2 3.4,2 3.6,2.2 L3.6,2.2 L7.5,6.1 C7.9,6.4 8.5,6.2 8.5,5.7 L8.5,5.7 L8.5,4.1 C8.5,3.8 8.8,3.5 9.1,3.5 L9.1,3.5 L9.9,3.5 C10.2,3.5 10.5,3.8 10.5,4.1 L10.5,4.1 L10.5,9.9 C10.5,10.2 10.2,10.5 9.9,10.5 L9.9,10.5 L4.1,10.5 C3.8,10.5 3.5,10.2 3.5,9.9 L3.5,9.9 L3.5,9.1 C3.5,8.8 3.8,8.5 4.1,8.5 L4.1,8.5 L5.7,8.5 C6.2,8.5 6.5,7.9 6.1,7.5 L6.1,7.5 L2.2,3.6 C2,3.4 2,3 2.2,2.8 L2.2,2.8 Z M20.4,2.2 C20.6,2 21,2 21.2,2.2 L21.2,2.2 L21.8,2.8 C22,3 22,3.4 21.8,3.6 L21.8,3.6 L17.9,7.5 C17.5,7.9 17.8,8.5 18.3,8.5 L18.3,8.5 L19.9,8.5 C20.2,8.5 20.5,8.8 20.5,9.1 L20.5,9.1 L20.5,9.9 C20.5,10.2 20.2,10.5 19.9,10.5 L19.9,10.5 L14.1,10.5 C13.8,10.5 13.5,10.2 13.5,9.9 L13.5,9.9 L13.5,4.1 C13.5,3.8 13.8,3.5 14.1,3.5 L14.1,3.5 L14.9,3.5 C15.2,3.5 15.5,3.8 15.5,4.1 L15.5,4.1 L15.5,5.7 C15.5,6.2 16.1,6.5 16.5,6.1 L16.5,6.1 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const FullScreenExitIcon = wrapSvgPath(fullScreenExitIcon);

const myLocationIcon = (
  <g>
    <circle id="Path" fillRule="nonzero" cx="11.5" cy="11.5" r="4" />
    <path
      d="M20.9,10.5 L19.9,10.5 C19.6,10.5 19.4,10.3 19.3,10 C18.7,6.8 16.1,4.2 12.9,3.6 C12.7,3.6 12.5,3.4 12.5,3.1 L12.5,2.2 C12.5,1.8 12.2,1.5 11.9,1.5 L11,1.5 C10.8,1.5 10.5,1.8 10.5,2.1 L10.5,3.1 C10.5,3.4 10.3,3.6 10,3.7 C6.8,4.3 4.2,6.8 3.6,10.1 C3.6,10.3 3.4,10.5 3.1,10.5 L2.1,10.5 C1.8,10.5 1.5,10.8 1.5,11.1 L1.5,12 C1.5,12.2 1.8,12.5 2.1,12.5 L3.1,12.5 C3.4,12.5 3.6,12.7 3.7,13 C4.3,16.2 6.9,18.8 10.1,19.4 C10.4,19.5 10.6,19.7 10.6,20 L10.6,21 C10.6,21.3 10.9,21.6 11.2,21.6 L12.1,21.6 C12.4,21.6 12.7,21.3 12.7,21 L12.7,20 C12.7,19.7 12.9,19.5 13.2,19.4 C16.4,18.8 19,16.2 19.6,13 C19.7,12.7 19.9,12.5 20.2,12.5 L21.1,12.5 C21.5,12.5 21.8,12.2 21.8,11.9 L21.8,11 C21.5,10.8 21.2,10.5 20.9,10.5 Z M12.9,17.3 C8.5,18.3 4.7,14.4 5.7,10.1 C6.2,7.9 8,6.1 10.2,5.6 C14.6,4.6 18.4,8.5 17.4,12.8 C16.9,15.1 15.1,16.9 12.9,17.3 Z"
      id="Shape"
      fillRule="nonzero"
    />
  </g>
);
export const MyLocationIcon = wrapSvgPath(myLocationIcon);

const placeIcon = (
  <path
    d="M12,2 C7.3,2 3.5,5.7 3.5,10.2 C3.5,15.6 10.2,22 12,22 C13.8,22 20.5,15.6 20.5,10.2 C20.5,5.7 16.7,2 12,2 Z M12,14 C10.1,14 8.5,12.4 8.5,10.5 C8.5,8.6 10.1,7 12,7 C13.9,7 15.5,8.6 15.5,10.5 C15.5,12.4 13.9,14 12,14 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const PlaceIcon = wrapSvgPath(placeIcon);

const phoneIcon = (
  <path
    d="M16.0574055,21.9402264 C17.9494704,22.4777047 19.9881577,19.2281708 20.0000975,18.6836088 C20.0204292,17.7548337 16.8245571,14.8803183 16.3565395,15.1052268 C15.6201827,15.4589965 13.458629,16.108798 13.0814837,16.0143196 C11.6943987,15.6663247 8.09149716,10.0815979 8.44838233,8.83238055 C8.54515571,8.49304475 10.2551116,7.14252745 10.9653737,6.74886655 C11.4172751,6.49849868 10.2334165,2.58446047 9.32433256,2.13568788 C8.79149263,1.87272363 4.62759566,1.82784637 4.20178652,3.56310112 C2.73405841,9.54332859 9.53664125,20.0876513 16.0574055,21.9402241 L16.0574055,21.9402264 Z"
    id="Path"
    fillRule="nonzero"
  />
);
export const PhoneIcon = wrapSvgPath(phoneIcon);

const directionsIcon = (
  <path
    d="M12.4085106,0.153191489 C12.2042553,-0.0510638298 11.7957447,-0.0510638298 11.5914894,0.153191489 L0.153191489,11.5914894 C-0.0510638298,11.7957447 -0.0510638298,12.2042553 0.153191489,12.4085106 L11.5914894,23.8468085 C11.7957447,24.0510638 12.2042553,24.0510638 12.4085106,23.8468085 L23.8468085,12.4085106 C24.0510638,12.2042553 24.0510638,11.7957447 23.8468085,11.5914894 L12.4085106,0.153191489 Z M17.7191489,12.2042553 L14.7574468,15.0638298 C14.3489362,15.3702128 13.8382979,15.1659574 13.8382979,14.6553191 L13.8382979,13.3276596 C13.8382979,13.0212766 13.6340426,12.7148936 13.2255319,12.7148936 L9.75319149,12.7148936 C9.44680851,12.7148936 9.14042553,12.9191489 9.14042553,13.3276596 L9.14042553,15.2680851 C9.14042553,15.5744681 8.93617021,15.8808511 8.52765957,15.8808511 L7.7106383,15.8808511 C7.40425532,15.8808511 7.09787234,15.6765957 7.09787234,15.2680851 L7.09787234,11.2851064 C7.09787234,10.9787234 7.30212766,10.6723404 7.7106383,10.6723404 L13.2255319,10.6723404 C13.5319149,10.6723404 13.8382979,10.4680851 13.8382979,10.0595745 L13.8382979,8.73191489 C13.8382979,8.2212766 14.4510638,8.01702128 14.8595745,8.32340426 L17.8212766,11.387234 C17.9234043,11.693617 17.9234043,12 17.7191489,12.2042553 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const DirectionsIcon = wrapSvgPath(directionsIcon);

const scheduleIcon = (
  <path
    d="M12,2 C17.5,2 22,6.5 22,12 C22,17.5 17.5,22 12,22 C6.5,22 2,17.5 2,12 C2,6.5 6.5,2 12,2 Z M12,4 C7.6,4 4,7.6 4,12 C4,16.4 7.6,20 12,20 C16.4,20 20,16.4 20,12 C20,7.6 16.4,4 12,4 Z M12.4516129,6 C12.7419355,6 13.0322581,6.29577465 13.0322581,6.5915493 L13.0322581,10.4366197 C13.0322581,10.7323944 13.3225806,11.028169 13.6129032,11.028169 L16.4193548,11.028169 C16.7096774,11.028169 17,11.3239437 17,11.6197183 L17,12.4084507 C17,12.7042254 16.7096774,13 16.4193548,13 L11.5806452,13 C11.2903226,13 11,12.6056338 11,12.3098592 L11,6.5915493 C11,6.29577465 11.2903226,6 11.5806452,6 L12.4516129,6 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const ScheduleIcon = wrapSvgPath(scheduleIcon);

const searchIcon = (
  <path
    d="M16.7,15.4 L21.4,20.1 C21.6,20.3 21.6,20.7 21.4,20.9 L20.8,21.5 C20.6,21.7 20.2,21.7 20,21.5 L15.3,16.8 C15.1,16.6 15.1,16.2 15.3,16 L15.9,15.4 C16.1,15.2 16.5,15.2 16.7,15.4 Z M9.5,2 C13.6,2 17,5.4 17,9.5 C17,13.6 13.6,17 9.5,17 C5.4,17 2,13.6 2,9.5 C2,5.4 5.4,2 9.5,2 Z M9.5,4 C6.5,4 4,6.5 4,9.5 C4,12.5 6.5,15 9.5,15 C12.5,15 15,12.5 15,9.5 C15,6.5 12.5,4 9.5,4 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const SearchIcon = wrapSvgPath(searchIcon);

const downloadIcon = (
  <g>
    <path
      d="M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7"
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <polyline
      data-name="Right"
      fill="none"
      id="Right-2"
      points="7.9 12.3 12 16.3 16.1 12.3"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <line
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      x1="12"
      x2="12"
      y1="2.7"
      y2="14.2"
    />
  </g>
);
export const DownloadIcon = wrapSvgPath(downloadIcon);

const mapPinIcon = (
  <path
    d="M16.7,15.4 L21.4,20.1 C21.6,20.3 21.6,20.7 21.4,20.9 L20.8,21.5 C20.6,21.7 20.2,21.7 20,21.5 L15.3,16.8 C15.1,16.6 15.1,16.2 15.3,16 L15.9,15.4 C16.1,15.2 16.5,15.2 16.7,15.4 Z M9.5,2 C13.6,2 17,5.4 17,9.5 C17,13.6 13.6,17 9.5,17 C5.4,17 2,13.6 2,9.5 C2,5.4 5.4,2 9.5,2 Z M9.5,4 C6.5,4 4,6.5 4,9.5 C4,12.5 6.5,15 9.5,15 C12.5,15 15,12.5 15,9.5 C15,6.5 12.5,4 9.5,4 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const MapPinIcon = wrapSvgPath(mapPinIcon);

const pagesIcon = (
  <path
    d="M6.91176471,16.5 C7.20588235,16.5 7.5,16.7941176 7.5,17.0882353 L7.5,20.9117647 C7.5,21.2058824 7.20588235,21.5 6.91176471,21.5 L3.08823529,21.5 C2.79411765,21.5 2.5,21.2058824 2.5,20.9117647 L2.5,17.0882353 C2.5,16.7941176 2.79411765,16.5 3.08823529,16.5 L6.91176471,16.5 Z M13.9117647,16.5 C14.2058824,16.5 14.5,16.7941176 14.5,17.0882353 L14.5,20.9117647 C14.5,21.2058824 14.2058824,21.5 13.9117647,21.5 L10.0882353,21.5 C9.79411765,21.5 9.5,21.2058824 9.5,20.9117647 L9.5,17.0882353 C9.5,16.7941176 9.79411765,16.5 10.0882353,16.5 L13.9117647,16.5 Z M20.9117647,16.5 C21.2058824,16.5 21.5,16.7941176 21.5,17.0882353 L21.5,20.9117647 C21.5,21.2058824 21.2058824,21.5 20.9117647,21.5 L17.0882353,21.5 C16.7941176,21.5 16.5,21.2058824 16.5,20.9117647 L16.5,17.0882353 C16.5,16.7941176 16.7941176,16.5 17.0882353,16.5 L20.9117647,16.5 Z M6.91176471,9.5 C7.20588235,9.5 7.5,9.79411765 7.5,10.0882353 L7.5,13.9117647 C7.5,14.2058824 7.20588235,14.5 6.91176471,14.5 L3.08823529,14.5 C2.79411765,14.5 2.5,14.2058824 2.5,13.9117647 L2.5,10.0882353 C2.5,9.79411765 2.79411765,9.5 3.08823529,9.5 L6.91176471,9.5 Z M13.9117647,9.5 C14.2058824,9.5 14.5,9.79411765 14.5,10.0882353 L14.5,13.9117647 C14.5,14.2058824 14.2058824,14.5 13.9117647,14.5 L10.0882353,14.5 C9.79411765,14.5 9.5,14.2058824 9.5,13.9117647 L9.5,10.0882353 C9.5,9.79411765 9.79411765,9.5 10.0882353,9.5 L13.9117647,9.5 Z M20.9117647,9.5 C21.2058824,9.5 21.5,9.79411765 21.5,10.0882353 L21.5,13.9117647 C21.5,14.2058824 21.2058824,14.5 20.9117647,14.5 L17.0882353,14.5 C16.7941176,14.5 16.5,14.2058824 16.5,13.9117647 L16.5,10.0882353 C16.5,9.79411765 16.7941176,9.5 17.0882353,9.5 L20.9117647,9.5 Z M6.82525952,2.5 C7.11361015,2.5 7.40196078,2.79411765 7.40196078,3.08823529 L7.40196078,6.91176471 C7.40196078,7.20588235 7.11361015,7.5 6.82525952,7.5 L3.07670127,7.5 C2.78835063,7.5 2.5,7.20588235 2.5,6.91176471 L2.5,3.08823529 C2.5,2.79411765 2.78835063,2.5 3.07670127,2.5 L6.82525952,2.5 Z M13.9117647,2.5 C14.2058824,2.5 14.5,2.79411765 14.5,3.08823529 L14.5,6.91176471 C14.5,7.20588235 14.2058824,7.5 13.9117647,7.5 L10.0882353,7.5 C9.79411765,7.5 9.5,7.20588235 9.5,6.91176471 L9.5,3.08823529 C9.5,2.79411765 9.79411765,2.5 10.0882353,2.5 L13.9117647,2.5 Z M20.9117647,2.5 C21.2058824,2.5 21.5,2.79411765 21.5,3.08823529 L21.5,6.91176471 C21.5,7.20588235 21.2058824,7.5 20.9117647,7.5 L17.0882353,7.5 C16.7941176,7.5 16.5,7.20588235 16.5,6.91176471 L16.5,3.08823529 C16.5,2.79411765 16.7941176,2.5 17.0882353,2.5 L20.9117647,2.5 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const PagesIcon = wrapSvgPath(pagesIcon);

const flyersIcon = (
  <path
    d="M12,10 C13.2,10 14.4,10.5 15.3,11.3 C16.2,12.2 16.7,13.3 16.7,14.5 C16.7,15.6 16.1,16.9 15.2,18.2 C13.9,20 12.4,21 12,21 C11.6,21 10.1,20 8.8,18.2 C7.8,16.9 7.3,15.6 7.3,14.5 C7.3,13.3 7.8,12.1 8.7,11.3 C9.6,10.5 10.8,10 12,10 Z M17.5,3 C18.7,3 19.9,3.2 21,3.5 C21.6,3.7 22.1,3.9 22.5,4.2 C22.7,4.4 22.9,4.7 22.9,5 L22.9,5 L22.9,19 C22.9,19.3 22.6,19.5 22.4,19.5 L22.4,19.5 L22.2,19.5 C20.7,18.8 19.1,18.5 17.4,18.5 C17.1,18.5 16.6,18.5 16.2,18.6 C16.7,17.9 17.1,17.2 17.3,16.5 L17.3,16.5 L17.8428571,16.5005831 C18.5285714,16.5040816 19.2142857,16.5285714 19.9,16.7 C20.5,16.8 21,16.4 21,15.8 L21,15.8 L21,6.2 C21,5.8 20.7,5.4 20.4,5.3 C19.4,5.1 18.5,5 17.5,5 C16,5 13.9,5.5 12.5,6.2 C12.2,6.3 12,6.6 12,7 L12,7 L12,8.3 C12,8.7 11.7,9.1 11.2,9.2 C10,9.3 8.9,9.9 8,10.7 C6.9,11.7 6.3,13.1 6.3,14.6 C6.3,15.8 6.8,17.1 7.7,18.5 C7.3,18.4 6.9,18.4 6.5,18.4 C5,18.4 3,18.9 1.7,19.5 L1.7,19.5 L1.5,19.5 C1.2,19.5 1,19.2 1,19 L1,19 L1,5 C1,4.7 1.1,4.4 1.4,4.2 C2.9,3.3 4.7,3 6.5,3 C8.3,3 10.1,3.3 11.5,4.2 C11.8,4.4 12.2,4.4 12.5,4.2 C13.9,3.3 15.7,3 17.5,3 Z M12,13 C11,13 10.1,13.9 10.1,15 C10.1,16.1 10.9,17 12,17 C13.1,17 13.9,16.1 13.9,15 C13.9,13.9 13,13 12,13 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const FlyersIcon = wrapSvgPath(flyersIcon);

const storesIcon = (
  <path
    d="M5.6,3 L18.5,3 C18.7,3 19,3.3 19,3.6 L19,4.5 C19,4.7 18.7,5 18.4,5 L5.6,5 C5.3,5 5,4.7 5,4.4 L5,3.6 C5,3.3 5.3,3 5.6,3 Z M21.4,14 L20.5,14 C20.2,14 19.9,14.3 19.9,14.6 L19.9,20.5 C19.9,20.8 19.6,21.1 19.3,21.1 L10.4,21.1 C10.1,21.1 9.8,20.8 9.8,20.5 L9.8,14.6 C9.8,14.3 9.5,14 9.2,14 L6.6,14 C6.3,14 6,14.3 6,14.6 L6,20.5 C6,20.7 5.7,21 5.4,21 L4.6,21 C4.3,21 4,20.7 4,20.4 L4,14.5 C4,14.3 3.7,14 3.4,14 L2.6,14 C2.3,14 2,13.7 2,13.4 L2,12.1 L2,12 L4.9,6.2 C5,6.1 5.1,6 5.2,6 C6.7,6 17.3,6.1 18.8,6 C18.9,6 19,6.1 19.1,6.2 L22,12 L22,12.1 L22,13.4 C22,13.7 21.7,14 21.4,14 Z M17.4,14 L12.5,14 C12.2,14 11.9,14.3 11.9,14.6 L11.9,18.5 C11.9,18.8 12.2,19.1 12.5,19.1 L17.4,19.1 C17.7,19.1 18,18.8 18,18.5 L18,14.6 C18,14.3 17.7,14 17.4,14 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const StoresIcon = wrapSvgPath(storesIcon);

const storeLocationIcon = (
  <path
    d="M11.5372 0.666992C13.9968 0.667098 15.6053 2.62779 15.295 4.91016C15.1729 5.80786 14.7283 6.73029 14.1866 7.56641C14.1868 7.57194 14.1886 7.57745 14.1886 7.58301V14.292C14.1886 14.8667 13.7167 15.3328 13.1349 15.333H2.52646C2.04142 15.333 1.64756 14.9449 1.64756 14.4658V8.83984C0.983572 8.79509 0.519677 8.15444 0.710056 7.51172L2.05381 2.97559C2.18529 2.53198 2.59751 2.22754 3.06552 2.22754H8.30381C8.97144 1.26151 10.1271 0.666992 11.5372 0.666992ZM3.05283 13.9453H5.55283V11.4492C5.55283 10.8745 6.02468 10.4084 6.60654 10.4082H9.37314C9.85817 10.4082 10.251 10.7964 10.2511 11.2754V13.9453H12.7833V9.37988C12.4806 9.7183 12.2045 10.0046 11.9884 10.2178C11.7357 10.4669 11.3377 10.4678 11.0841 10.2197C10.7586 9.9013 10.2952 9.42101 9.81357 8.84473H3.05283V13.9453ZM6.9581 13.9453H8.84677V11.7959H6.9581V13.9453ZM11.5372 2.05469C10.6626 2.05469 10.0216 2.3699 9.62802 2.80273C9.23878 3.23087 8.99792 3.87539 9.11338 4.72559C9.20942 5.43232 9.65229 6.30369 10.297 7.19531C10.7048 7.75932 11.1502 8.27175 11.5333 8.68066C11.9065 8.27762 12.3382 7.7733 12.7345 7.2168C13.3633 6.33353 13.803 5.45653 13.9024 4.72559C14.104 3.24286 13.1134 2.05479 11.5372 2.05469ZM2.19052 7.45703H4.55185L5.28134 3.61523H3.32822L2.19052 7.45703ZM5.98154 7.45703H8.78427C8.26083 6.64511 7.83654 5.76185 7.7208 4.91016C7.65883 4.45394 7.66785 4.01969 7.73935 3.61523H6.71103L5.98154 7.45703ZM11.5089 3.20703C12.2451 3.20719 12.8419 3.80473 12.8419 4.54102C12.8417 5.27713 12.245 5.87387 11.5089 5.87402C10.7726 5.87402 10.1751 5.27723 10.1749 4.54102C10.1749 3.80464 10.7725 3.20703 11.5089 3.20703Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const StoreLocationIcon = wrapSvgPath(storeLocationIcon, '0 0 16 16');

const menuIcon = (
  <path
    d="M21.4029851,17 C21.7014925,17 22,17.3 22,17.6 L22,18.5 C21.9004975,18.7 21.60199,19 21.3034826,19 L2.59701493,19 C2.29850746,19 2,18.7 2,18.4 L2,17.5 C2,17.3 2.29850746,17 2.59701493,17 L21.4029851,17 Z M21.4029851,11 C21.7014925,11 22,11.3 22,11.6 L22,12.5 C21.9004975,12.7 21.60199,13 21.3034826,13 L2.59701493,13 C2.29850746,13 2,12.7 2,12.4 L2,11.5 C2,11.3 2.29850746,11 2.59701493,11 L21.4029851,11 Z M21.5,5 C21.7,5 22,5.3 22,5.6 L22,6.5 C22,6.7 21.7,7 21.4,7 L2.6,7 C2.3,7 2,6.7 2,6.4 L2,5.6 C2,5.3 2.3,5 2.6,5 L21.5,5 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const MenuIcon = wrapSvgPath(menuIcon);

const verticalScrollIcon = (
  <path
    d="M12.1836152,13.0363961 C12.4664579,13.0363961 12.7493006,13.3192388 12.7493006,13.6020815 L12.7493006,13.6020815 L12.7493006,17.8004606 C12.8200113,18.2954353 13.3856967,18.578278 13.7392501,18.2247247 L13.7392501,18.2247247 L14.870621,17.0933538 C15.082753,16.8812218 15.5070171,16.8812218 15.7191491,17.0933538 L15.7191491,17.0933538 L16.2848346,17.6590392 C16.4969666,17.8711713 16.4969666,18.2954353 16.2848346,18.5075674 L16.2848346,18.5075674 L12.1836152,22.6087867 C11.9714832,22.8209187 11.5472191,22.8209187 11.3350871,22.6087867 L11.3350871,22.6087867 L7.23386775,18.5075674 C7.02173572,18.2954353 7.02173572,17.8711713 7.23386775,17.6590392 L7.23386775,17.6590392 L7.79955318,17.0933538 C8.01168521,16.8812218 8.43594928,16.8812218 8.64808131,17.0933538 L8.64808131,17.0933538 L9.77945216,18.2247247 C10.1330056,18.578278 10.7694017,18.366146 10.7694017,17.8004606 L10.7694017,17.8004606 L10.7694017,13.6020815 C10.7694017,13.3192388 11.0522444,13.0363961 11.3350871,13.0363961 L11.3350871,13.0363961 Z M11.3350871,1.42426407 C11.5472191,1.21213203 11.9714832,1.21213203 12.1836152,1.42426407 L12.1836152,1.42426407 L16.2848346,5.5254834 C16.4969666,5.73761543 16.4969666,6.1618795 16.2848346,6.37401154 L16.2848346,6.37401154 L15.7191491,6.93969696 C15.5070171,7.151829 15.082753,7.151829 14.870621,6.93969696 L14.870621,6.93969696 L13.7392501,5.80832611 C13.3856967,5.45477272 12.7493006,5.66690476 12.7493006,6.23259018 L12.7493006,6.23259018 L12.7493006,10.4309692 C12.7493006,10.713812 12.4664579,10.9966547 12.1836152,10.9966547 L12.1836152,10.9966547 L11.3350871,10.9966547 C11.0522444,10.9966547 10.7694017,10.713812 10.7694017,10.4309692 L10.7694017,10.4309692 L10.7694017,6.23259018 C10.698691,5.73761543 10.1330056,5.45477272 9.77945216,5.80832611 L9.77945216,5.80832611 L8.64808131,6.93969696 C8.43594928,7.151829 8.01168521,7.151829 7.79955318,6.93969696 L7.79955318,6.93969696 L7.23386775,6.37401154 C7.02173572,6.1618795 7.02173572,5.73761543 7.23386775,5.5254834 L7.23386775,5.5254834 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const VerticalScrollIcon = wrapSvgPath(verticalScrollIcon);

const horizontalScrollIcon = (
  <path
    d="M5.5254834,7.49104198 C5.73761543,7.27890995 6.1618795,7.27890995 6.37401154,7.49104198 L6.37401154,7.49104198 L6.93969696,8.05672741 C7.151829,8.26885944 7.151829,8.69312351 6.93969696,8.90525555 L6.93969696,8.90525555 L5.80832611,10.0366264 C5.45477272,10.3901798 5.66690476,11.0265759 6.23259018,11.0265759 L6.23259018,11.0265759 L10.4309692,11.0265759 C10.713812,11.0265759 10.9966547,11.3094186 10.9966547,11.5922613 L10.9966547,11.5922613 L10.9966547,12.4407895 C10.9966547,12.7236322 10.713812,13.0064749 10.4309692,13.0064749 L10.4309692,13.0064749 L6.23259018,13.0064749 C5.73761543,13.0771856 5.45477272,13.642871 5.80832611,13.9964244 L5.80832611,13.9964244 L6.93969696,15.1277952 C7.151829,15.3399273 7.151829,15.7641913 6.93969696,15.9763234 L6.93969696,15.9763234 L6.37401154,16.5420088 C6.1618795,16.7541408 5.73761543,16.7541408 5.5254834,16.5420088 L5.5254834,16.5420088 L1.42426407,12.4407895 C1.21213203,12.2286574 1.21213203,11.8043933 1.42426407,11.5922613 L1.42426407,11.5922613 Z M17.6590392,7.49104198 C17.8711713,7.27890995 18.2954353,7.27890995 18.5075674,7.49104198 L18.5075674,7.49104198 L22.6087867,11.5922613 C22.8209187,11.8043933 22.8209187,12.2286574 22.6087867,12.4407895 L22.6087867,12.4407895 L18.5075674,16.5420088 C18.2954353,16.7541408 17.8711713,16.7541408 17.6590392,16.5420088 L17.6590392,16.5420088 L17.0933538,15.9763234 C16.8812218,15.7641913 16.8812218,15.3399273 17.0933538,15.1277952 L17.0933538,15.1277952 L18.2247247,13.9964244 C18.578278,13.642871 18.366146,13.0064749 17.8004606,13.0064749 L17.8004606,13.0064749 L13.6020815,13.0064749 C13.3192388,13.0064749 13.0363961,12.7236322 13.0363961,12.4407895 L13.0363961,12.4407895 L13.0363961,11.5922613 C13.0363961,11.3094186 13.3192388,11.0265759 13.6020815,11.0265759 L13.6020815,11.0265759 L17.8004606,11.0265759 C18.2954353,10.9558652 18.578278,10.3901798 18.2247247,10.0366264 L18.2247247,10.0366264 L17.0933538,8.90525555 C16.8812218,8.69312351 16.8812218,8.26885944 17.0933538,8.05672741 L17.0933538,8.05672741 Z"
    id="Shape"
    fillRule="nonzero"
  />
);
export const HorizontalScrollIcon = wrapSvgPath(horizontalScrollIcon);

const shareIcon = (
  <path
    d="M19.1522093,14.1545647 C17.9587193,14.0552933 16.8646868,14.5516502 16.0690268,15.4450927 C15.8701118,15.6436355 15.6711968,15.6436355 15.4722818,15.5443641 L9.40537433,12.8640367 C9.40537433,12.8640367 9.10700183,12.6654939 9.10700183,12.0698656 C9.10700183,11.4742373 9.40537433,11.2756945 9.40537433,11.2756945 L15.4722818,8.59536709 C15.6711968,8.49609571 15.9695693,8.59536709 16.0690268,8.69463848 C16.8646868,9.58808095 17.9587193,9.98516649 19.1522093,9.98516649 C20.9424443,9.88589511 22.5337643,8.59536709 22.9315943,6.80848215 C23.4288818,4.02888335 21.1413593,1.6463701 18.4560068,2.04345564 C16.7652293,2.3412698 15.4722818,3.7310692 15.1739093,5.41868275 C14.9749943,5.91503968 14.9749943,6.21285384 14.9749943,6.41139661 C14.9749943,6.60993938 14.8755368,6.90775354 14.6766218,7.00702492 L8.60971433,9.58808095 C8.41079933,9.68735233 8.11242684,9.58808095 8.01296934,9.48880956 C7.21730934,8.69463848 6.32219184,8.29755294 5.22815935,8.19828155 C3.33846686,8.09901016 1.44877437,9.58808095 1.05094437,11.4742373 C0.653114369,13.9560219 2.64226436,16.1399924 5.02924435,16.1399924 C6.22273434,16.1399924 7.21730934,15.6436355 7.91351184,14.8494644 C8.11242684,14.6509216 8.31134183,14.5516502 8.60971433,14.6509216 L14.6766218,17.2319776 C14.8755368,17.331249 15.0744518,17.5297918 14.9749943,17.827606 C14.9749943,18.2246915 14.9749943,18.8203198 15.3728243,19.6144909 C16.0690268,20.9050189 17.3619743,21.8977328 18.8538368,21.9970042 C21.4397318,22.0962755 23.5283393,19.7137623 22.8321368,17.0334349 C22.4343068,15.6436355 20.7435293,14.2538361 19.1522093,14.1545647 Z"
    id="shareIcon"
    fillRule="nonzero"
  />
);
export const ShareIcon = wrapSvgPath(shareIcon);

const indexIcon = (
  <g>
    <path d="M19,1h-2H1.5C1.2,1,1,1.2,1,1.5v21C1,22.8,1.2,23,1.5,23h17c0.3,0,0.5-0.2,0.5-0.5v-7c0-0.3,0.2-0.5,0.5-0.5h0c1.9,0,3.5-1.6,3.5-3.5V11V9V7V5V1.5C23,1.2,22.8,1,22.5,1H19z M16.5,21h-13C3.2,21,3,20.8,3,20.5v-17C3,3.2,3.2,3,3.5,3h13C16.8,3,17,3.2,17,3.5V5v2v2v2v4v5.5C17,20.8,16.8,21,16.5,21z M21,11.5c0,0.8-0.7,1.5-1.5,1.5h0c-0.3,0-0.5-0.2-0.5-0.5v-1c0-0.3,0.2-0.5,0.5-0.5h1C20.8,11,21,11.2,21,11.5L21,11.5z M20.5,9h-1C19.2,9,19,8.8,19,8.5v-1C19,7.2,19.2,7,19.5,7h1C20.8,7,21,7.2,21,7.5v1C21,8.8,20.8,9,20.5,9z M19,4.5v-1C19,3.2,19.2,3,19.5,3h1C20.8,3,21,3.2,21,3.5v1C21,4.8,20.8,5,20.5,5h-1C19.2,5,19,4.8,19,4.5z" />
    <path d="M6.5,13h7c0.3,0,0.5-0.2,0.5-0.5v-1c0-0.3-0.2-0.5-0.5-0.5h-7C6.2,11,6,11.2,6,11.5v1C6,12.8,6.2,13,6.5,13z" />
    <path d="M6.5,9h7C13.8,9,14,8.8,14,8.5v-1C14,7.2,13.8,7,13.5,7h-7C6.2,7,6,7.2,6,7.5v1C6,8.8,6.2,9,6.5,9z" />
    <path d="M6.5,17h7c0.3,0,0.5-0.2,0.5-0.5v-1c0-0.3-0.2-0.5-0.5-0.5h-7C6.2,15,6,15.2,6,15.5v1C6,16.8,6.2,17,6.5,17z" />
  </g>
);
export const IndexIcon = wrapSvgPath(indexIcon);

const whatsappIcon = (
  <g id="ico_sv_share_whatsapp_1_">
    <path
      d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M12.1,17.8c-1,0-1.9-0.2-2.8-0.7L6,18l1-3.2
        c-0.5-0.9-0.7-1.9-0.7-2.9C6.2,8.6,8.9,6,12.1,6c3.2,0,5.9,2.6,5.9,5.9C18,15.2,15.4,17.8,12.1,17.8z"
    />
    <path
      d="M12.1,7.1c-2.6,0-4.8,2.1-4.8,4.8c0,0.9,0.2,1.7,0.7,2.5l0.1,0.2l-0.5,1.8l1.8-0.5L9.7,16c0.7,0.4,1.6,0.7,2.4,0.7
        c2.6,0,4.8-2.1,4.8-4.8C16.9,9.3,14.7,7.1,12.1,7.1z M14.8,13.8c-0.2,0.4-0.6,0.7-1.1,0.8c-0.4,0.1-0.8-0.1-1.2-0.2
        c-0.4-0.1-0.7-0.3-1-0.5c-0.6-0.4-1.2-0.9-1.6-1.5c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2-0.3-0.3-0.5-0.4-0.8c0-0.1,0-0.2,0-0.4
        c0-0.4,0.2-0.9,0.5-1.2c0.2-0.2,0.5-0.2,0.7-0.1c0.2,0.1,0.4,0.5,0.5,0.7c0.1,0.2,0.2,0.4,0.2,0.7c0,0.2-0.2,0.4-0.3,0.6
        c-0.1,0.1-0.1,0.2,0,0.3c0.5,0.8,1.1,1.3,1.9,1.6c0.1,0,0.2,0,0.3-0.1c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.1,0.6,0,0.8,0.2
        c0.2,0.1,0.6,0.3,0.7,0.6C14.8,13.5,14.8,13.7,14.8,13.8z"
    />
    <path
      fill="#FFFFFE"
      d="M12.1,6c-3.2,0-5.9,2.6-5.9,5.9c0,1,0.3,2,0.7,2.9L6,18l3.3-0.9c0.9,0.5,1.8,0.7,2.8,0.7
        c3.2,0,5.9-2.6,5.9-5.9C18,8.6,15.4,6,12.1,6z M12.1,16.7c-0.9,0-1.7-0.2-2.4-0.7l-0.2-0.1l-1.8,0.5l0.5-1.8L8,14.4
        c-0.5-0.8-0.7-1.6-0.7-2.5c0-2.6,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8C16.9,14.5,14.7,16.7,12.1,16.7z"
    />
    <path
      fill="#FFFFFE"
      d="M14.1,12.8c-0.2-0.1-0.6-0.3-0.8-0.2c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.1-0.2,0.1-0.3,0.1
        c-0.8-0.3-1.5-0.9-1.9-1.6c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.2,0.3-0.3,0.3-0.6c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.2-0.2-0.6-0.5-0.7
        c-0.2-0.1-0.5-0.1-0.7,0.1c-0.4,0.3-0.5,0.7-0.5,1.2c0,0.1,0,0.3,0,0.4c0.1,0.3,0.2,0.6,0.4,0.8c0.1,0.2,0.2,0.4,0.4,0.6
        c0.4,0.6,1,1.1,1.6,1.5c0.3,0.2,0.7,0.4,1,0.5c0.4,0.1,0.8,0.3,1.2,0.2c0.4-0.1,0.9-0.4,1.1-0.8c0.1-0.1,0.1-0.3,0.1-0.4
        C14.8,13.1,14.4,13,14.1,12.8z"
    />
  </g>
);
export const WhatsappIcon = wrapSvgPath(whatsappIcon);

const facebookIcon = (
  <g id="ico_facebook_">
    <path
      d="M22,12c0-5.5-4.5-10-10-10S2,6.5,2,12c0,4.9,3.5,9,8.2,9.8v-5.9H8v-2.5h2.2v-1.9c0-2.2,1.3-3.4,3.3-3.4c1,0,1.9,0.2,1.9,0.2
  v2.1h-1.1c-1.1,0-1.4,0.7-1.4,1.4v1.6h2.4L15,15.9h-2V22C18,21.5,22,17.2,22,12z"
    />
    <path
      fill="#FFFFFE"
      d="M15,15.9l0.4-2.5h-2.4v-1.6c0-0.7,0.3-1.4,1.4-1.4h1.1V8.2c0,0-1-0.2-1.9-0.2c-2,0-3.3,1.2-3.3,3.4v1.9H8v2.5
  h2.2v5.9c0.6,0.1,1.2,0.2,1.8,0.2c0.3,0,0.6,0,0.9,0v-6.1H15z"
    />
  </g>
);
export const FacebookIcon = wrapSvgPath(facebookIcon);

const facebookMessengerIcon = (
  <g id="ico_messenger">
    <path
      d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M12,17.7c-0.9,0-1.7-0.2-2.4-0.5l-1.4,0.6
  c-0.4,0.2-0.8-0.1-0.8-0.6l0.2-1.4c-1-1-1.6-2.4-1.6-4C6,8.6,8.7,6,12,6c3.3,0,6,2.6,6,5.8C18,15.1,15.3,17.7,12,17.7z"
    />
    <path
      d="M15,10.5l-1.1,0.6l-0.7,0.4c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0-0.3,0-0.5-0.1l-1.3-0.9c-0.3-0.1-0.6,0-0.7,0.2l0,0l-1.9,2.4
  c-0.1,0.1,0,0.3,0.1,0.3c0.1,0,0.1,0.1,0.2,0l1.8-1c0.1,0,0.1-0.1,0.2-0.1c0.2,0,0.3,0,0.5,0.1l1.3,0.9c0.3,0.1,0.6,0,0.7-0.2l0,0
  l1.9-2.4c0.1-0.1,0-0.3-0.1-0.3C15.1,10.4,15,10.4,15,10.5z"
    />
    <path
      fill="#FFFFFE"
      d="M12,6c-3.3,0-6,2.6-6,5.8c0,1.5,0.6,2.9,1.6,4l-0.2,1.4c0,0.4,0.4,0.7,0.8,0.6l1.4-0.6c0.7,0.3,1.6,0.5,2.4,0.5
  c3.3,0,6-2.6,6-5.8C18,8.6,15.3,6,12,6z M15.2,10.8l-1.9,2.4l0,0c-0.2,0.2-0.5,0.3-0.7,0.2l-1.3-0.9c-0.1-0.1-0.3-0.1-0.5-0.1
  c-0.1,0-0.1,0-0.2,0.1l-1.8,1c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.2-0.1-0.3l1.9-2.4l0,0c0.2-0.2,0.5-0.3,0.7-0.2l1.3,0.9
  c0.1,0.1,0.3,0.1,0.5,0.1c0.1,0,0.1,0,0.2-0.1l0.7-0.4l1.1-0.6c0.1,0,0.2,0,0.2,0C15.3,10.6,15.3,10.7,15.2,10.8z"
    />
  </g>
);
export const FacebookMessengerIcon = wrapSvgPath(facebookMessengerIcon);

const emailShareIcon = (
  <g id="ico_share_email">
    <path
      d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M6.5,10l2.7,2.4l-2.7,2.4V10z M7.3,15.9l3-2.6
  c0.3,0.3,0.9,0.8,1.1,1c0.3,0.3,0.5,0.5,0.8,0.3l0.1-0.1c0.2-0.2,0.9-0.8,1.4-1.2c0.5,0.4,1.3,1.2,2.9,2.6H7.3z M17.5,14.8l-2.7-2.4
  l2.7-2.4V14.8z M12,13c-0.5-0.5-2.6-2.3-5.5-4.9l11-0.1L12,13z"
    />
    <path fill="#FFFFFE" d="M12,13l5.5-5l-11,0.1C9.4,10.7,11.5,12.6,12,13z" />
    <path
      fill="#FFFFFE"
      d="M12.4,14.5l-0.1,0.1c-0.3,0.2-0.5,0-0.8-0.3c-0.2-0.2-0.8-0.7-1.1-1l-3,2.6h9.4c-1.6-1.4-2.5-2.2-2.9-2.6
  C13.3,13.7,12.5,14.3,12.4,14.5z"
    />
    <polygon fill="#FFFFFE" points="17.5,14.8 17.5,10 14.8,12.4 " />
    <polygon fill="#FFFFFE" points="6.5,10 6.5,14.8 9.2,12.4 " />
  </g>
);
export const EmailShareIcon = wrapSvgPath(emailShareIcon);

const copyLinkShareIcon = (
  <g id="ico_share_link">
    <path
      d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M13,14.5l-1.8,1.8c-0.5,0.5-1.1,0.7-1.7,0.7
    c-0.6,0-1.3-0.3-1.7-0.7C7.3,15.8,7,15.2,7,14.6c0-0.6,0.3-1.3,0.7-1.7l1.4-1.4c0.2-0.2,0.5-0.2,0.6,0l0.1,0.1
    c0.2,0.2,0.2,0.5,0,0.6l-1.4,1.4c-0.3,0.3-0.4,0.6-0.4,0.9c0,0.4,0.1,0.7,0.4,0.9c0.3,0.3,0.6,0.4,0.9,0.4c0.4,0,0.7-0.1,0.9-0.4
    l1.8-1.8c0.2-0.3,0.4-0.6,0.4-0.9c0-0.4-0.1-0.7-0.4-0.9c0,0,0,0-0.1,0C12,11.7,12,11.6,12,11.4c0-0.1,0-0.2,0.1-0.3l0.1-0.1
    c0.2-0.2,0.4-0.2,0.6,0L13,11c0.5,0.5,0.7,1.1,0.7,1.7C13.7,13.4,13.4,14,13,14.5z M16.3,11.2l-1.4,1.4c-0.2,0.2-0.5,0.2-0.6,0
    l-0.1-0.1c-0.2-0.2-0.2-0.5,0-0.6l1.4-1.4c0.3-0.3,0.4-0.6,0.4-0.9c0-0.4-0.1-0.7-0.4-0.9c-0.2-0.3-0.6-0.4-0.9-0.4
    c-0.4,0-0.7,0.1-0.9,0.4l-1.8,1.8c-0.3,0.3-0.4,0.6-0.4,0.9s0.1,0.7,0.4,0.9c0,0,0,0,0.1,0c0.1,0.1,0.1,0.2,0.1,0.3
    c0,0.1,0,0.2-0.1,0.3L11.8,13c-0.2,0.2-0.4,0.2-0.6,0c0,0-0.1-0.1-0.1-0.1c-0.5-0.5-0.7-1.1-0.7-1.7c0-0.6,0.3-1.3,0.7-1.7l1.8-1.8
    C13.3,7.3,13.9,7,14.6,7c0.6,0,1.3,0.3,1.7,0.7C16.7,8.2,17,8.8,17,9.4C17,10.1,16.7,10.7,16.3,11.2z"
    />
    <path
      fill="#FFFFFE"
      d="M12.9,10.9c-0.2-0.2-0.5-0.2-0.6,0l-0.1,0.1C12,11.2,12,11.3,12,11.4c0,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0.1,0
    c0.2,0.3,0.4,0.6,0.4,0.9c0,0.4-0.1,0.7-0.4,0.9l-1.8,1.8c-0.2,0.3-0.6,0.4-0.9,0.4c-0.4,0-0.7-0.1-0.9-0.4
    c-0.3-0.3-0.4-0.6-0.4-0.9c0-0.4,0.1-0.7,0.4-0.9l1.4-1.4c0.2-0.2,0.2-0.5,0-0.6l-0.1-0.1c-0.2-0.2-0.5-0.2-0.6,0l-1.4,1.4
    C7.3,13.3,7,13.9,7,14.6c0,0.6,0.3,1.3,0.7,1.7C8.2,16.7,8.8,17,9.4,17c0.6,0,1.3-0.3,1.7-0.7l1.8-1.8c0.5-0.5,0.7-1.1,0.7-1.7
    C13.7,12.1,13.4,11.5,12.9,10.9L12.9,10.9z"
    />
    <path
      fill="#FFFFFE"
      d="M14.6,7c-0.6,0-1.3,0.3-1.7,0.7L11,9.5c-0.5,0.5-0.7,1.1-0.7,1.7c0,0.6,0.3,1.3,0.7,1.7c0,0,0.1,0.1,0.1,0.1
    c0.2,0.2,0.5,0.2,0.6,0l0.1-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0-0.1,0c-0.3-0.3-0.4-0.6-0.4-0.9
    s0.1-0.7,0.4-0.9l1.8-1.8c0.2-0.3,0.6-0.4,0.9-0.4c0.4,0,0.7,0.1,0.9,0.4c0.3,0.3,0.4,0.6,0.4,0.9c0,0.4-0.1,0.7-0.4,0.9l-1.4,1.4
    c-0.2,0.2-0.2,0.5,0,0.6l0.1,0.1c0.2,0.2,0.5,0.2,0.6,0l1.4-1.4c0.5-0.5,0.7-1.1,0.7-1.7c0-0.6-0.3-1.3-0.7-1.7
    C15.8,7.3,15.2,7,14.6,7z"
    />
  </g>
);
export const CopyLinkShareIcon = wrapSvgPath(copyLinkShareIcon);

const smsShareIcon = (
  <g id="ico_share_sms">
    <path
      d="M11,9.9C11,9.9,11,9.9,11,9.9C11,9.9,11,9.9,11,9.9c-0.6,0-1,0.5-1,1c0,0.6,0.4,1.1,1,1.1c0,0,0,0,0,0c0.5,0,1-0.5,1-1
    C12,10.4,11.6,9.9,11,9.9z"
    />
    <path d="M14,10C14,10,14,10,14,10c-0.6,0-1,0.5-1,1c0,0.6,0.4,1.1,1,1.1c0,0,0,0,0,0c0.5,0,1-0.5,1-1C15,10.5,14.6,10,14,10z" />
    <path d="M8,9.9C8,9.9,8,9.9,8,9.9c-0.6,0-1,0.5-1,1C7,11.5,7.4,12,8,12c0,0,0,0,0,0c0.5,0,1-0.5,1-1C9,10.4,8.6,9.9,8,9.9z" />
    <path
      d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M11,15.9c-1,0-2-0.2-2.7-0.5L5.5,16l0.7-2.2
    C5.4,13,5,11.8,5,10.7c0-0.4,0.1-0.9,0.3-1.3c0.4-1.1,1.2-2,2.2-2.5C8,6.6,8.6,6.3,9.2,6.2C9.8,6.1,10.3,6,10.9,6c0.1,0,0.2,0,0.4,0
    c1.3,0.1,2.6,0.5,3.6,1.2c0.9,0.7,1.7,1.6,2,2.7c0.1,0.4,0.2,0.9,0.1,1.3C16.8,14.5,13.8,15.9,11,15.9z M18.2,16.9l-1.7-0.4
    c-0.8,0.4-2,0.5-3.1,0.1c2.3-0.6,4.4-2.3,4.6-5.1c0.1,0.2,0.3,0.5,0.4,0.7c0.1,0.3,0.2,0.6,0.2,0.9c0,0.8-0.3,1.6-0.7,2.2L18.2,16.9
    z"
    />
    <path
      fill="#FFFFFE"
      d="M17,11.3c0-0.4,0-0.9-0.1-1.3c-0.3-1.1-1.1-2.1-2-2.7c-1.1-0.8-2.3-1.2-3.6-1.2c-0.1,0-0.2,0-0.4,0
    c-0.6,0-1.1,0.1-1.6,0.2C8.6,6.3,8,6.6,7.5,6.9c-1,0.6-1.8,1.4-2.2,2.5C5.1,9.8,5,10.2,5,10.7C5,11.8,5.4,13,6.1,13.8L5.5,16
    l2.8-0.6c0.8,0.4,1.7,0.5,2.7,0.5C13.8,15.9,16.8,14.5,17,11.3z M8,12C8,12,8,12,8,12c-0.6,0-1-0.5-1-1.1c0-0.6,0.4-1,1-1
    c0,0,0,0,0,0c0.5,0,1,0.5,1,1.1C9,11.5,8.5,12,8,12z M11,12C11,12,11,12,11,12c-0.6,0-1-0.5-1-1.1c0-0.6,0.4-1,1-1c0,0,0,0,0,0
    c0,0,0,0,0,0c0.5,0,1,0.5,1,1.1C12,11.6,11.5,12,11,12z M14,12.1C14,12.1,14,12.1,14,12.1c-0.6,0-1-0.5-1-1.1c0-0.6,0.4-1,1-1
    c0,0,0,0,0,0c0.5,0,1,0.5,1,1.1C15,11.6,14.5,12.1,14,12.1z"
    />
    <path
      fill="#FFFFFE"
      d="M18.3,12.3c-0.1-0.3-0.2-0.5-0.4-0.7c-0.2,2.8-2.3,4.4-4.6,5.1c1.1,0.4,2.3,0.3,3.1-0.1l1.7,0.4l-0.4-1.5
    c0.5-0.6,0.7-1.4,0.7-2.2C18.5,12.9,18.4,12.6,18.3,12.3z"
    />
  </g>
);
export const SmsShareIcon = wrapSvgPath(smsShareIcon);

const NoMedia = (
  <path
    d="M100 50c-27.6 0-50 22.4-50 50v800c0 27.6 22.4 50 50 50h800c27.6 0 50-22.4 50-50V100c0-27.6-22.4-50-50-50H100zm0-50h800c55.2 0 100 44.8 100 100v800c0 55.2-44.8 100-100 100H100C44.8 1000 0 955.2 0 900V100C0 44.8 44.8 0 100 0zm25 875h750V499.5c0-6.9-5.6-12.5-12.5-12.5-2.6 0-5.2.8-7.3 2.4L664.3 627.9c-18 13.1-42.5 12.7-60.1-1l-258-200.7c-19.4-15.1-46.9-13.9-64.8 2.9L133 567.6c-5.1 4.7-8 11.4-7.9 18.3-.1 0-.1 289.1-.1 289.1zm525-425c55.2 0 100-44.8 100-100s-44.8-100-100-100-100 44.8-100 100 44.8 100 100 100z"
    fill="#ebebf5"
  />
);
export const NoMediaIcon = wrapSvgPath(NoMedia, '0 0 1000 1000');

const playCircleXL = (
  <>
    <defs>
      <circle id="path-1" cx="80" cy="80" r="80" />
      <filter
        x="-4.4%"
        y="-3.1%"
        width="108.8%"
        height="108.8%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.251641757 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g id="play-card" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="round_shape" opacity="0.7">
        <use fill="black" fillOpacity="1" filter="url(#filter-2)" xlinkHref="#path-1" />
        <circle
          stroke="#FFFFFF"
          strokeWidth="2"
          strokeLinejoin="square"
          fill="currentColor"
          fillRule="evenodd"
          cx="80"
          cy="80"
          r="79"
        />
      </g>
      <path
        d="M96.0947624,55.5020807 L126.531566,101.648203 C129.572417,106.258525 128.300109,112.461026 123.689787,115.501877 C122.055742,116.579651 120.141312,117.15415 118.183839,117.15415 L57.3102317,117.15415 C51.7873842,117.15415 47.3102317,112.676998 47.3102317,107.15415 C47.3102317,105.196678 47.8847307,103.282247 48.9625049,101.648203 L79.3993088,55.5020807 C82.4401596,50.8917585 88.6426608,49.6194506 93.252983,52.6603014 C94.3827901,53.4054933 95.3495705,54.3722737 96.0947624,55.5020807 Z"
        id="Triangle"
        fill="#FFFFFF"
        transform="translate(87.747036, 80.000000) rotate(90.000000) translate(-87.747036, -80.000000) "
      />
    </g>
  </>
);
export const PlayCircleXLIcon = wrapSvgPath(playCircleXL, '0 0 160 160');
